



























import { Vue, Component } from "vue-property-decorator";
import api from "@/getinfo-api";
import CompanyPageForm from "@/components/companies/CompanyPageForm.vue";
import { Company as ICompany } from "@/api/models/company";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { Company } from "@/services/notifications";

@Component({
  components: { CompanyPageForm }
})
export default class CompanyEditView extends Vue {
  companyInfo!: ICompany;
  companyId: string = this.$route.params.id;
  notificationSettings: any = {
    course: {},
    test: {},
    order: {}
  };

  data() {
    return {
      companyInfo: undefined
    };
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.companyInfo?.owner?.id === this.userId;
  }

  get userAccessToEditCompany() {
    return this.root || this.companyOwner;
  }

  mounted() {
    api.CompanyApi.get(this.companyId)
      .then(async (res: { data: ICompany }) => {
        this.companyInfo = res.data;
        document.title += ` ${this.companyInfo.title}`;

        this.notificationSettings.course = await Company.getStudentStartLearningSettings(
          this.companyId
        );
        this.notificationSettings.order = await Company.getNewLearningRequestSettings(
          this.companyId
        );
        this.notificationSettings.test = await Company.getStudentFinishLearningSettings(
          this.companyId
        );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
